<script setup lang="ts">
  import { computed } from 'vue';
  import { IconRadio } from '@/shared/ui';
  import { DISPOSAL_OPTIONS } from '../../lib/record-config-options';
  import type { DisposalMode } from '../../model/record-config.types';

  const RADIO_GROUP = 'record-config-disposal';

  const props = defineProps<{
    modelValue: DisposalMode | null;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: DisposalMode];
  }>();

  const selected = computed(() => props.modelValue ?? undefined);
</script>

<template>
  <section class="flex flex-col gap-3 px-8 py-6" data-testid="record-config-disposal-section">
    <span class="text-sm font-semibold text-gray-07">Disposição (descarte):</span>
    <div class="flex flex-wrap gap-x-8 gap-y-3">
      <IconRadio
        v-for="option in DISPOSAL_OPTIONS"
        :key="option.id"
        :model-value="selected"
        :value="option.id"
        :label="option.name"
        :name="RADIO_GROUP"
        variant="medium"
        @update:model-value="emit('update:modelValue', $event)"
      />
    </div>
  </section>
</template>
